import ReactDOM from 'react-dom/client';
import '@backstage/cli/asset-types';
import app from './App';
import * as Sentry from '@sentry/react';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://ff4c0c5652b3dcf7b2b6c7d043afb82a@o136784.ingest.us.sentry.io/4510680819826688',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(app);
